export const getSortedEpisodes = (season) =>
    season
        .getEpisodes()
        .sort(
            (episode, nextEpisode) =>
                (episode.getRawData().episodeNumber || 0) -
                (nextEpisode.getRawData().episodeNumber || 0)
        );

export const findNextEpisode = (series, currentEpisodeItem) => {
    let nextEp;
    if (!series) return undefined;
    series.getSeasons().forEach((season) => {
        getSortedEpisodes(season).forEach((episode, episodeIndex, episodes) => {
            if (currentEpisodeItem.getId().toString() === episode.getId().toString()) {
                nextEp = episodes[episodeIndex + 1];
            }
        });
    });
    return nextEp;
};
